import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGeoObjects, useGeoObjectBalloon } from './hooks';
import { trackGeoClick, trackInfrastructureClick } from './tracking';
import { setActivePin } from '../../actions/map';
import { Map } from '../../components/Map';
import { selectMapData, selectActivePin, selectResults, selectSelectedId } from '../../selectors';
import { getFolderOffersByRealtyOfferId } from '../../thunk/favorites';
import { useApplicationContext } from '../../utils/applicationContext';

export const INFRASTRUCTURE_MAIN = 'main';

interface IMapContainerProps {
  onClose(): void;
}

export const MapContainer: React.FC<IMapContainerProps> = ({ onClose }) => {
  const dispatch = useDispatch();
  const [currentTypes, setCurrentTypes] = React.useState([INFRASTRUCTURE_MAIN]);

  const { offerPins, infrastructurePins } = useSelector(selectMapData);
  const activePin = useSelector(selectActivePin);
  const selectedFolderId = useSelector(selectSelectedId);
  const { favoriteEntities } = useSelector(selectResults);

  const { config } = useApplicationContext();

  const firstFavoriteEntityId = favoriteEntities && favoriteEntities[0]?.entityId;
  const firstOffer = offerPins.find(offer => offer.realtyOfferId === firstFavoriteEntityId);
  const apiKey = config.getStrict<string>('b2b.YandexApiKey');

  React.useEffect(() => {
    if (activePin) {
      dispatch(getFolderOffersByRealtyOfferId({ folderId: Number(selectedFolderId), realtyOfferIds: [activePin] }));
    }
  }, [selectedFolderId, activePin, dispatch]);

  const { infrastructureItemsRef, infrastructureTypes, onGeoObjectsFirstFetch } = useGeoObjects();

  const { onBalloonHtmlFirstFetch } = useGeoObjectBalloon({
    infrastructureItemsRef,
  });

  const setInfrastructureType = React.useCallback(
    (type: string) => {
      setCurrentTypes([INFRASTRUCTURE_MAIN, type]);
      trackInfrastructureClick(offerPins, type);
    },
    [offerPins],
  );

  const handleGeoClick = (geo: IGeoObject) => {
    if (geo.name === INFRASTRUCTURE_MAIN) {
      const offerId = Number(geo.options.id);

      dispatch(setActivePin(offerId));
      trackGeoClick(offerId);
    }
  };

  return (
    <Map
      types={currentTypes}
      apiKey={apiKey}
      infrastructurePins={infrastructurePins}
      infrastructureTypes={infrastructureTypes}
      coordinates={firstOffer?.coordinates}
      handleGeoObjectsFirstFetch={onGeoObjectsFirstFetch}
      handleBalloonHtmlFirstFetch={onBalloonHtmlFirstFetch}
      handleGeoClick={handleGeoClick}
      handleClose={onClose}
      setInfrastructureType={setInfrastructureType}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default MapContainer;
